import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";

import { OrdersWrapper } from "../orderHistory.styles";
import OrderCard from "./OrderCard";
import { useGetGroupedArrayOrders } from "../../../../AuthenticatedApp/components/productCatalogue/common/hooks/useGetGroupedOrders";
import Loader from "../../../../../library/Loader";
import EmptyState from "../../../common/components/EmptyState";
import { EmptyOrderHistoryIcon } from "../../../common/assets/icons/orderHistoryIcons";

const Orders = ({ searchedItems, activePage }) => {
    const { groupedArrays } = useGetGroupedArrayOrders(searchedItems);
    const { orderHistoryState, orderHistory } = useSelector((state) => state.catalogueState);

    if ((orderHistoryState === "idle" || orderHistoryState === "loading") && !orderHistory) {
        return (
            <OrdersWrapper>
                <Loader />
            </OrdersWrapper>
        );
    }

    return (
        <OrdersWrapper>
            {searchedItems?.length > 0 ? (
                <>
                    {groupedArrays?.map((date, index) => (
                        <div key={"orders-" + date + index}>
                            <div className="catalogue__orders-header">
                                <h5>{moment(date.date).format("DD/MM/YYYY")}</h5>
                            </div>
                            <>
                                {groupedArrays[index]?.orders.map((order, index) => (
                                    <OrderCard
                                        order={order}
                                        key={order.id}
                                        activePage={activePage}
                                    />
                                ))}
                            </>
                        </div>
                    ))}
                </>
            ) : (
                <EmptyState
                    emptyIcon={<EmptyOrderHistoryIcon />}
                    title="Nothing to see yet"
                    details={
                        activePage === 0
                            ? "We’ll show open orders here."
                            : activePage === 1
                            ? "We’ll show settled orders here."
                            : "We’ll show saved orders here."
                    }
                />
            )}
        </OrdersWrapper>
    );
};

export default Orders;
